var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./user_avatar_link.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bcca3766\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./user_avatar_link.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue_shared/components/user_avatar/user_avatar_link.vue
// module id = ./vue_shared/components/user_avatar/user_avatar_link.vue
// module chunks = common_vue